import React from "react";

import {
  Modal,
  Input,
  Button,
  Select,
  Form,
  Table,
  Popconfirm,
  Upload,
  Alert,
  Descriptions,
} from "antd";

import { useState, useEffect, useContext } from "react";

import {
  GetIndoorRaceResults,
  GetEventEntries,
  GetSchools,
  GetRowers,
  GetRaces,
  AddIndoorRaceResults,
  DeleteIndoorRaceResults,
  GetIndoorRecords,
  AddNewIndoorRecord,
} from "../../APIManager";

import { SecurityScanFilled, UploadOutlined } from "@ant-design/icons";

import { ListOfEvents } from "../../constants";

export default function IndoorResults() {
  const [raceResults, SetRaceResults] = useState([]);
  const [eventEntries, SetEventEntries] = useState([]);
  const [schools, SetSchools] = useState([]);
  const [rowers, SetRowers] = useState([]);
  const [races, SetRaces] = useState([]);
  const [indoorRecords, SetIndoorRecords] = useState([]);
  const [addModalOpen, SetModalOpen] = useState(false);

  const [awaitingResponse, SetAwaitingResponse] = useState(true);

  useEffect(() => {
    SetAwaitingResponse(true); // Set loading state to true before starting fetch
    const fetchAllData = async () => {
      try {
        // Fetch all data concurrently
        const [
          schoolsRes,
          rowersRes,
          racesRes,
          indoorRecordsRes,
          raceResultsRes,
          eventEntriesRes,
        ] = await Promise.all([
          GetSchools(),
          GetRowers(),
          GetRaces(),
          GetIndoorRecords(),
          GetIndoorRaceResults(),
          GetEventEntries(),
        ]);

        // Set the fetched data
        SetSchools(schoolsRes.data);
        SetRowers(rowersRes.data);
        SetRaces(racesRes.data);
        SetIndoorRecords(indoorRecordsRes.data);
        SetRaceResults(raceResultsRes.data);
        SetEventEntries(eventEntriesRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // Ensure loading is set to false regardless of success or failure
        SetAwaitingResponse(false);
      }
    };

    fetchAllData();
  }, []);

  function FetchData() {
    GetIndoorRaceResults().then((res) => {
      SetRaceResults(res.data);
      SetAwaitingResponse(false);
    });
    GetEventEntries().then((res) => {
      SetEventEntries(res.data);
    });
  }

  function GetSchoolInfo(id) {
    return schools.filter((s) => s._id == id)[0];
  }

  if (
    awaitingResponse ||
    eventEntries.length < 1 ||
    schools.length < 1 ||
    rowers.length < 1 ||
    races.length < 1
  ) {
    return <h1>Loading</h1>;
  }

  const listOfRaces = [
    ...new Set(
      races.filter((r) => r.Class == "Indoor Race").map((r) => r.EventName)
    ),
  ];

  const columns = [
    {
      title: "Event Name",
      dataIndex: "EventName",
      render: (text, record) => (
        <>
          <span>{record.EventName} </span>
          <Popconfirm
            placement="bottomLeft"
            title={
              "Are you sure you want to delete these race results. This action cannot be undone"
            }
            onConfirm={() => {
              DeleteIndoorRaceResults(record.EventName).then(() => {
                FetchData();
              });
            }}
            okText="Yes"
            cancelText="No"
          >
            <span style={{ color: "blue" }}> Delete</span>
          </Popconfirm>
        </>
      ),
    },
    {
      title: "1st",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[0].id).schoolinitials}
          <br />
          {record.Results[0]?.time}
        </>
      ),
    },
    {
      title: "2nd",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[1]?.id)?.schoolinitials} <br />
          {record.Results[1]?.time}
        </>
      ),
    },
    {
      title: "3rd",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[2]?.id)?.schoolinitials} <br />
          {record.Results[2]?.time}
        </>
      ),
    },
    {
      title: "4th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[3]?.id)?.schoolinitials} <br />
          {record.Results[3]?.time}
        </>
      ),
    },
    {
      title: "5th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[4]?.id)?.schoolinitials} <br />
          {record.Results[4]?.time}
        </>
      ),
    },
    {
      title: "6th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[5]?.id)?.schoolinitials} <br />
          {record.Results[5]?.time}
        </>
      ),
    },
    {
      title: "7th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[6]?.id)?.schoolinitials} <br />
          {record.Results[6]?.time}
        </>
      ),
    },
    {
      title: "8th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[7]?.id)?.schoolinitials} <br />
          {record.Results[7]?.time}
        </>
      ),
    },
    {
      title: "9th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[8]?.id)?.schoolinitials} <br />
          {record.Results[8]?.time}
        </>
      ),
    },
    {
      title: "10th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[9]?.id)?.schoolinitials} <br />
          {record.Results[9]?.time}
        </>
      ),
    },
    {
      title: "11th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[10]?.id)?.schoolinitials} <br />
          {record.Results[10]?.time}
        </>
      ),
    },
    {
      title: "12th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[11]?.id)?.schoolinitials} <br />
          {record.Results[11]?.time}
        </>
      ),
    },
    {
      title: "13th",
      key: "Results",
      render: (text, record) => (
        <>
          {GetSchoolInfo(record.Results[12]?.id)?.schoolinitials} <br />
          {record.Results[12]?.time}
        </>
      ),
    },
  ];

  return (
    <div>
      <h1 style={{ fontSize: "1.5em" }}>Indoor Race Results</h1>
      <Button
        type="primary"
        onClick={() => {
          SetModalOpen(true);
        }}
      >
        Add Race Results
      </Button>

      <Table
        columns={columns}
        dataSource={raceResults}
        pagination={{ defaultPageSize: 50 }}
      />

      <AddModal
        key={`Indoor Race Results Modal ${addModalOpen}`}
        modalVisible={addModalOpen}
        OnSubmit={(e) => {
          SetModalOpen(false);

          const { eventname, times, splits } = e;
          let raceorder = [];

          e.schools.forEach((s) => {
            const time = times[s];
            raceorder.push({
              time: time,
              username: s,
              id: schools.filter((sc) => sc.username == s)[0]._id,
              splits: splits[s] ? splits[s] : [],
            });
          });

          // Sort raceorder, placing races with "00:00:0" at the end
          raceorder.sort((a, b) => {
            if (a.time === "00:00:0") return 1; // Push "00:00:0" to the end
            if (b.time === "00:00:0") return -1;
            return a.time > b.time ? 1 : a.time < b.time ? -1 : 0;
          });

          // Filter out races with "00:00:0" for processing
          const validRaceOrder = raceorder.filter((r) => r.time !== "00:00:0");

          // Add race results
          AddIndoorRaceResults({
            EventName: eventname,
            Results: raceorder, // Include all results (valid + "00:00:0")
          }).then(() => {
            FetchData();
          });

          // Process records for valid races only
          const record = indoorRecords.CurrentRecords.find(
            (r) => r.EventName === eventname
          );

          if (record && validRaceOrder.length > 0) {
            if (validRaceOrder[0].time < record.Time) {
              const recordSchoolID = validRaceOrder[0].id;

              const raceObject = races.find(
                (r) =>
                  r.EventName === eventname &&
                  r.Participants.map((p) => p.school).includes(recordSchoolID)
              );

              const entry = eventEntries.find(
                (e) => e.RaceName === eventname && e.Team === recordSchoolID
              );

              if (raceObject && entry) {
                const allRowers = [
                  ...entry.Rowers,
                  ...entry.SubRowers,
                  ...entry.Coxers,
                  ...entry.SubCoxers,
                ];

                let participatingRowers = allRowers.filter((r) =>
                  raceObject.PontoonSheet.map((s) => s.id).includes(r)
                );

                participatingRowers = participatingRowers.map((p) =>
                  rowers.find((r) => r._id === p)
                );

                const year = new Date().getFullYear();
                AddNewIndoorRecord(
                  eventname,
                  participatingRowers.map((r) => r.Name).join(", "),
                  participatingRowers[0].Team.schoolname,
                  validRaceOrder[0].time,
                  year
                ).then(() => {
                  FetchData();
                });
              }
            }
          }
        }}
        onCloseModal={() => {
          SetModalOpen(false);
        }}
        listOfRaces={listOfRaces.filter((r) => {
          return !raceResults.map((rr) => rr.EventName).includes(r);
        })}
        eventEntries={eventEntries}
        schools={schools}
        records={indoorRecords.CurrentRecords}
      />
      <div></div>
    </div>
  );
}

const AddModal = ({
  modalVisible,
  OnSubmit,
  onCloseModal,
  listOfRaces,
  eventEntries,
  schools,
  records,
  raceFileDetails,
}) => {
  const [raceresultsFile, SetRaceResultsFile] = useState(null);
  const [raceFilevalidation, SetRaceFileValidation] = useState(null);
  const [isRaceFileModalVisible, SetIsRaceModalVisible] = useState(false);

  const [form] = Form.useForm();
  const [formValues, SetFormValues] = useState({});

  const [submitEnabled, SetSubmitEnabled] = useState(false);

  const [splits, SetSplits] = useState({});

  const [splitsModalOpen, SetSplitsModalOpen] = useState(false);
  const [selectedSplits, SetSelectedSplits] = useState([]);

  // New state for class selection
  const [uniqueClasses, SetUniqueClasses] = useState([]);
  const [selectedClass, SetSelectedClass] = useState(null);
  const [isClassSelectionModalVisible, SetIsClassSelectionModalVisible] = useState(false);

  const { Option } = Select;

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ EventName: formValues.EventName });
    SetFormValues({ EventName: formValues.EventName });
  }, [formValues.EventName]);

  var entries = eventEntries.filter((e) => e.RaceName == formValues.EventName);
  entries.forEach((entry, index) => {
    entries[index].School = schools.filter((s) => s._id == entry.Team)[0];
  });

  const record = records.filter((r) => r.EventName == formValues.EventName)[0];

  var submitValid = GetSubmitValid();

  function GetSubmitValid() {
    var schoolnames = entries.map((e) => e.School.username);
    var isValid = true;
    schoolnames.forEach((name) => {
      if (!formValues[name]) {
        isValid = false;
        console.log(name);
      } else {
        let re = /^\d{2}:\d{2}:\d$/;
        if (!re.test(formValues[name])) {
          isValid = false;
          console.log("Invalid");
        }
      }
    });

    if (form.getFieldsError().filter(({ errors }) => errors.length).length) {
      console.log(form.getFieldsError().filter(({ errors }) => errors.length));
      isValid = false;
    }

    return isValid;
  }

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target.result);
        SetRaceResultsFile(json);
        const validationResults = validateRaceResults(rac2Config, json);
        SetRaceFileValidation(validationResults);

        if (!validationResults.success) {
          SetIsRaceModalVisible(true);
        } else {
          // Extract unique classes from participants
          const classes = [...new Set(
            json.results.participants.map((p) => p.class || "")
          )];
          SetUniqueClasses(classes);
          SetSelectedClass(classes[0]); // Select first by default
          SetIsClassSelectionModalVisible(true);
        }
      } catch (err) {
        SetRaceFileValidation({
          success: false,
          invaid: true,
          inconsistencies: ["Invalid file format."],
        });
        SetIsRaceModalVisible(true);
      }
    };
    reader.readAsText(file);
    return false; // Prevent upload to server
  };

  function ProcessRaceFile(classToImport = selectedClass) {
    const newForm = { EventName: formValues.EventName };

    const processedSplits = { ...splits };

    // Filter participants by selected class
    const filteredParticipants = raceresultsFile.results.participants.filter(
      (p) => (p.class || "") === classToImport
    );

    entries.forEach((entry) => {
      const raceresult = filteredParticipants.filter(
        (p) => p.participant == entry.School.schoolinitials
      )[0]?.time;

      const splitTimes = filteredParticipants.filter(
        (p) => p.participant == entry.School.schoolinitials
      )[0]?.splits;

      console.log(splitTimes);

      if (raceresult) {
        newForm[entry.School.username] = convertToMMSSS(raceresult);

        processedSplits[entry.School.username] = splitTimes;
      }
    });

    form.setFieldsValue(newForm);
    SetFormValues(newForm);
    SetSplits(processedSplits);

    console.log(splits);

    console.log(newForm);
  }

  return (
    <>
      {" "}
      <SplitsModal
        isOpen={splitsModalOpen}
        onClose={() => {
          SetSplitsModalOpen(false);
        }}
        splits={selectedSplits}
      />
      {/* Class Selection Modal */}
      <Modal
        title="Select Class to Import"
        visible={isClassSelectionModalVisible}
        onCancel={() => SetIsClassSelectionModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => SetIsClassSelectionModalVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="import"
            type="primary"
            disabled={selectedClass === null}
            onClick={() => {
              SetIsClassSelectionModalVisible(false);
              ProcessRaceFile(selectedClass);
            }}
          >
            Import Selected
          </Button>,
        ]}
      >
        <p>Select which class you want to import results for:</p>
        <Select
          style={{ width: "100%" }}
          placeholder="Select class to import"
          value={selectedClass}
          onChange={(value) => SetSelectedClass(value)}
        >
          {uniqueClasses.map((className, index) => (
            <Option key={index} value={className}>
              {className || "(No Class / Empty)"}
            </Option>
          ))}
        </Select>
      </Modal>
      <Modal
        title="Validation Results"
        visible={isRaceFileModalVisible}
        onCancel={() => SetIsRaceModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => SetIsRaceModalVisible(false)}>
            Close
          </Button>,
        ]}
      >
        {raceFilevalidation?.inconsistencies && (
          <>
            <Alert message="Warning!" type="warning" showIcon />
            <ul>
              {raceFilevalidation?.inconsistencies.map((issue, index) => (
                <li key={index}>{issue}</li>
              ))}
            </ul>
            <Button type="primary" block onClick={() => {
              SetIsRaceModalVisible(false);
              // Extract unique classes from participants
              const classes = [...new Set(
                raceresultsFile.results.participants.map((p) => p.class || "")
              )];
              SetUniqueClasses(classes);
              SetSelectedClass(classes[0]); // Select first by default
              SetIsClassSelectionModalVisible(true);
            }}>
              Proceed Anyways
            </Button>
          </>
        )}
      </Modal>
      <Modal
        title={`Add race results`}
        forceRender
        visible={modalVisible}
        onOk={() => {}}
        onCancel={onCloseModal}
        okText="Add"
        cancelText="Cancel"
        width="600px"
        okButtonProps={{
          disabled: !submitValid,
          onClick: () => {
            OnSubmit({
              times: formValues,
              schools: [...entries.map((e) => e.School.username)],
              eventname: formValues.EventName,
              splits: splits,
            });
          },
        }}
        // cancelButtonProps={{ hidden: true }}
        maskClosable={false}
      >
        <div>
          <Upload beforeUpload={handleFileUpload} accept=".json">
            <Button icon={<UploadOutlined />}>Upload Race Results File</Button>
          </Upload>
          <Form
            name="basic"
            form={form}
            initialValues={{ remember: true }}
            onFinish={() => {
              // SetFormStep(2);
            }}
            //onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="horizontal"
            size="large"
            onValuesChange={() => {
              SetFormValues(form.getFieldsValue());
              //GetSubmitValid()
              console.log(form.getFieldsValue());
            }}
          >
            <Form.Item
              label="Event Name"
              name="EventName"
              rules={[
                {
                  required: true,
                  message: "Please input an Event Name",
                },
                {
                  message: "This race has already been setup",
                  validator: (_, value) => {
                    return Promise.resolve();
                    /*   if (!races.map((r) => r.EventName).includes(value)) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject("This race has already been setup");
                  } */
                  },
                },
              ]}
            >
              <Select showSearch>
                {listOfRaces.map(function (item, i) {
                  return <Option value={item}>{item}</Option>;
                })}
              </Select>
            </Form.Item>
            {entries.map((e, index) => {
              var recordText = "";
              let re = /^\d{2}:\d{2}:\d$/;
              if (record && re.test(formValues[e.School.username])) {
                recordText =
                  formValues[e.School.username] < record.Time
                    ? "(New Record!)"
                    : "";
              }
              return (
                <>
                  {" "}
                  <Form.Item
                    label={`${e.School.username} ${recordText}`}
                    name={e.School.username}
                    rules={[
                      {
                        required: true,
                        message: "Input race time",
                      },
                      {
                        message: "Enter in the format 'MM:SS:S' ",
                        validator: (_, value) => {
                          let re = /^\d{2}:\d{2}:\d$/;
                          if (re.test(value)) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject(
                              "Enter in the format 'MM:SS:S' "
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <Input
                      suffix={
                        <div
                          style={{
                            cursor: splits[e.School.username]
                              ? "pointer"
                              : "default",
                          }}
                          onClick={() => {
                            if (splits[e.School.username]) {
                              SetSplitsModalOpen(true);
                              SetSelectedSplits(splits[e.School.username]);
                            }
                          }}
                        >
                          {splits[e.School.username]
                            ? "Split Data"
                            : "No Split Data"}
                        </div>
                      }
                    />
                  </Form.Item>
                </>
              );
            })}
          </Form>
        </div>
      </Modal>
    </>
  );
};

// Hardcoded RAC2 Configuration
const rac2Config = {
  name_long: "Under 25 Boys 1 x 500m Race A",
  name_short: "Under 25 Boys 1 x 500m Race A",
  duration_type: "meters",
  duration: 500,
  race_type: "individual",
  split_type: "even",
  split_value: 100,
  race_id: "6774f252041ef3a96614fac7",
  boats: [
    { class_name: "", lane_number: 1, name: "ZIA", participants: [] },
    { class_name: "", lane_number: 2, name: "AKU", participants: [] },
    { class_name: "", lane_number: 3, name: "DEN", participants: [] },
    { class_name: "", lane_number: 4, name: "IBA", participants: [] },
    { class_name: "", lane_number: 5, name: "IDR", participants: [] },
    { class_name: "", lane_number: 6, name: "HBU", participants: [] },
  ],
};

// Validation Function
const validateRaceResults = (rac2Config, raceResults) => {
  return {
    success: true,
    inconsistencies: [],
  };
  const inconsistencies = [];

  if (
    rac2Config.race_id &&
    rac2Config.race_id !== raceResults.results.race_id
  ) {
    inconsistencies.push(
      `Mismatch in race_id: Expected ${rac2Config.race_id}, found ${
        raceResults.results.race_id || "undefined"
      }`
    );
  }

  if (rac2Config.duration !== raceResults.results.duration) {
    inconsistencies.push(
      `Mismatch in duration: Expected ${rac2Config.duration}, found ${raceResults.results.duration}`
    );
  }

  if (rac2Config.race_type !== raceResults.results.race_type) {
    inconsistencies.push(
      `Mismatch in race_type: Expected ${rac2Config.race_type}, found ${raceResults.results.race_type}`
    );
  }

  const rac2Lanes = rac2Config.boats.map((boat) => ({
    lane: boat.lane_number,
    name: boat.name,
  }));
  const resultLanes = raceResults.results.participants.map((participant) => ({
    lane: participant.lane,
    participant: participant.participant,
  }));

  const missingLanes = rac2Lanes.filter(
    (rac2Boat) => !resultLanes.some((result) => result.lane === rac2Boat.lane)
  );
  const extraLanes = resultLanes.filter(
    (result) => !rac2Lanes.some((rac2Boat) => rac2Boat.lane === result.lane)
  );

  if (missingLanes.length) {
    inconsistencies.push(
      `Missing lanes in results: ${missingLanes
        .map((boat) => boat.lane)
        .join(", ")}`
    );
  }
  if (extraLanes.length) {
    inconsistencies.push(
      `Extra lanes in results: ${extraLanes
        .map((result) => result.lane)
        .join(", ")}`
    );
  }

  rac2Lanes.forEach((rac2Boat) => {
    const resultBoat = resultLanes.find(
      (result) => result.lane === rac2Boat.lane
    );
    if (resultBoat && rac2Boat.name !== resultBoat.participant) {
      inconsistencies.push(
        `Mismatch in lane ${rac2Boat.lane}: Expected name "${rac2Boat.name}", found participant "${resultBoat.participant}"`
      );
    }
  });

  if (
    rac2Config.name_long &&
    rac2Config.name_long !== raceResults.results.race_name
  ) {
    inconsistencies.push(
      `Mismatch in race name: Expected ${rac2Config.name_long}, found ${raceResults.results.race_name}`
    );
  }

  return {
    success: inconsistencies.length === 0,
    inconsistencies,
  };
};

function convertToMMSSS(timeString) {
  // Split the time string
  const [minutes, secondsWithFraction] = timeString.split(":");
  const [seconds, fraction] = secondsWithFraction.split(".");

  // Format the minutes and seconds with zero padding
  const paddedMinutes = minutes.padStart(2, "0");
  const paddedSeconds = seconds.padStart(2, "0");

  // Replace the last period with a colon in the fractional part
  const formattedFraction = fraction.replace(/\./, ":");

  // Format the output
  return `${paddedMinutes}:${paddedSeconds}:${formattedFraction}`;
}

function GetRAC2Config(raceName) {}

const SplitsModal = ({ isOpen, onClose, splits }) => {
  const testsplits = [
    {
      split_avg_pace: "3:12.0",
      split_calories: 5,
      split_distance: 100,
      split_drag_factor: 119,
      split_running_calories: 5,
      split_running_distance: 100,
      split_running_time: 384,
      split_stroke_count: 15,
      split_stroke_rate: 23,
      split_time: 384,
      split_type: "distance_split",
    },
    {
      split_avg_pace: "3:12.0",
      split_calories: 5,
      split_distance: 100,
      split_drag_factor: 119,
      split_running_calories: 5,
      split_running_distance: 100,
      split_running_time: 384,
      split_stroke_count: 15,
      split_stroke_rate: 23,
      split_time: 384,
      split_type: "distance_split",
    },
    {
      split_avg_pace: "3:12.0",
      split_calories: 5,
      split_distance: 100,
      split_drag_factor: 119,
      split_running_calories: 5,
      split_running_distance: 100,
      split_running_time: 384,
      split_stroke_count: 15,
      split_stroke_rate: 23,
      split_time: 384,
      split_type: "distance_split",
    },
  ];

  const columns = [
    {
      title: "Metric",
      dataIndex: "metric",
      key: "metric",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
    },
  ];

  const formatSplits = (split) =>
    Object.entries(split).map(([key, value]) => ({
      key,
      metric: key.replace(/_/g, " ").toUpperCase(),
      value,
    }));

  const formatKey = (key) => key.replace(/_/g, " ").toUpperCase();

  return (
    <div>
      <Modal
        title="Splits Details"
        visible={isOpen}
        onCancel={() => onClose(false)}
        footer={[
          <Button key="close" onClick={() => onClose(false)}>
            Close
          </Button>,
        ]}
        width={800}
      >
        {splits.map((split, index) => (
          <div key={index} style={{ marginBottom: "16px" }}>
            <h3>Split {index + 1}</h3>
            <Descriptions
              bordered
              size="small"
              column={2}
              layout="horizontal"
              labelStyle={{ fontWeight: "bold", textTransform: "capitalize" }}
            >
              {Object.entries(split).map(([key, value]) => (
                <Descriptions.Item key={key} label={formatKey(key)}>
                  {value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </div>
        ))}
      </Modal>
    </div>
  );
};
